export default "__VITE_ASSET__Ddiz$Hq8__"